export enum ListSourceType {
    CATALOGUE = 'catalogue',
    CART = 'shoppingcart',
    SELECTION_LIST = 'selectionlist',
    PRODUCT_GROUP = 'productgroup',
    BUNDLE = 'bundle',
    COMPLETE_COLLECTION = 'cc',
    COMPLETE_COLLECTION_NEWLY_ADDED = 'cc_newly_added',
    COMPLETE_COLLECTION_BY_GENRE = 'cc_by_genre',
    LOTE = 'lote',
    LOTE_NEWLY_ADDED = 'lote_newly_added',
    LOTE_BY_GENRE = 'lote_by_genre',
    LANGUAGE_LEARNING = 'll',
    LANGUAGE_LEARNING_NEWLY_ADDED = 'll_newly_added',
    CAMPAIGN_PRODUCTS = 'campaign_products'
}
